// extracted by mini-css-extract-plugin
module.exports = {"container":"P_c","dots":"P_b9","dot":"P_bY"};